<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>

            <h2>
                NOVO PROCEDIMENTO!
            </h2>
            <h3>
               Informamos que o processo de adesão ao cartão foi alterado. Já não será possível realizar o mesmo online.<br><br>
               Agora deverá dirigir-se a uma loja makro (à receção de clientes) e ao solicitar o seu cartão digital “Family&Friends”, indique a empresa onde trabalha, e com a qual, a makro tem parceria.<br><br>
               Logo após a adesão, e nesse mesmo dia, poderá começar a realizar as suas compras.<br><br>
               Obrigada pela compreensão!
            </h3>
<!--
            <h2>
                Peça já o seu Cartão<sup>*</sup>
            </h2>
            <fieldset v-if="formStep === 1">
                <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            placeholder="Nome e Apelido"
                            v-model="fullName"
                        >
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|email" v-slot="{ classes }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            placeholder="Email"
                            v-model.lazy="email"
                        >
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|nif" v-slot="{ classes }">
                    <div class="input-group input-group-nif" :class="classes">
                        <input type="tel"
                            placeholder="Contribuinte"
                            v-model="nif"
                            v-mask="'#########'"
                        >
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|phone:pt" v-slot="{ classes }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            placeholder="Nº Telemóvel"
                            v-model="phone"
                            v-mask="'#########'"
                        >
                    </div>
                </validation-provider>
                <button class="btn-cta" type="submit">
                    Continuar
                </button>
            </fieldset>
            <fieldset v-if="formStep === 2">
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-street" :class="classes">
                        <input type="text"
                            placeholder="Morada"
                            v-model="street"
                        >
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-city" :class="classes">
                        <input type="text"
                            placeholder="Localidade"
                            v-model.lazy="city"
                        >
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|zip:pt" v-slot="{ classes }">
                    <div class="input-group input-group-city" :class="classes">
                        <input type="tel"
                            placeholder="Código Postal"
                            v-model="zip"
                            v-mask="'####-###'"
                        >
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <label class="form-check-label" :class="classes">
                        <input type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                        <span class="check"></span>
                        <span>Autorizo a Makro a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                    </label>
                </validation-provider>
                <button
                    class="btn-cta"
                    type="submit"
                    :disabled="$store.state.formLoading"
                >
                    ENVIAR
                </button>
            </fieldset>
            <div class="steps">
                <span :class="{'active' : formStep >= 1}"></span>
                <span :class="{'active' : formStep >= 2}"></span>
            </div> -->
        </form>
    </validation-observer>
</template>

<script>
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/nif';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            email: '',
            nif: '',
            phone: '',

            street: '',
            city: '',
            zip: '',

            formStep: 1,

            usedClasses: ['.has-error'],
        };
    },
    methods: {
        formSubmit() {
            if (this.formStep < 2) {
                this.formStep += 1;
                return;
            }
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                ip: this.$store.state.ip,
                user_agent: window.navigator.userAgent,
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                ua_device: this.$store.state.ua_device,
                ua_browser: this.$store.state.ua_browser,
                ua_os: this.$store.state.ua_os,
                token: this.$store.state.token,

                fullName: this.fullName,
                email: this.email,
                nif: this.nif,
                phone: this.phone,

                street: this.street,
                city: this.city,
                zip: this.zip,

            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>
